import { takeLatest, call, put } from 'redux-saga/effects';
import api from '../../api/index';
import {
  GET_USER_FAVORITES, SET_USER_FAVORITES, USER_FAVORITES_REQUEST_FAILED, SENDING_USER_FAVORITES_REQUEST,
} from '../../types/Types';

/**
 * Call the api and dispatch data to the reducer
 * @param { Object } action Contained object data to be send to API call
 */
export function* getUserFavorites(action) {
  const { data } = action;

  try {
    yield put({
      type: SENDING_USER_FAVORITES_REQUEST,
      fData: '',
      isFSending: true,
      isFSuccess: false,
      fError: false,
    });
    const response = yield call(api.favorites.getFavorites, data);
    // console.log(response);
    if (response) {
      // eslint-disable-next-line new-cap
      const jsonData = new Buffer.from(response, 'base64');
      const favData = JSON.parse(jsonData.toString());
      yield put({
        type: SET_USER_FAVORITES,
        fData: favData,
        isFSending: false,
        fError: false,
        isFSuccess: true,
      });
    } else {
      yield put({
        type: USER_FAVORITES_REQUEST_FAILED,
        fData: null,
        isFSending: false,
        fError: true,
        isFSuccess: false,
        fMsg: response.errorMsg,
      });
    }
  } catch (e) {
    yield put({
      type: USER_FAVORITES_REQUEST_FAILED,
      fMsg: e.message,
      isFSending: false,
      fError: true,
      isFSuccess: false,
      fData: null,
    });
  }
}

/**
 * map the dispatched action to the above function
 */
export default function* watchGetUserFavorites() {
  yield takeLatest(GET_USER_FAVORITES, getUserFavorites);
}
